/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Embed_Captions_File_Size_GbInputs */

const en_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

const fr_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} Go)`)
};

const de_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

const it_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

const ru_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

const es_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

const zh_cn2_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.size} GB）`)
};

const ja_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.size} GB）`)
};

const hi_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} जीबी)`)
};

const pt_pt2_embed_captions_file_size_gb = /** @type {(inputs: Embed_Captions_File_Size_GbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
};

/**
* | output |
* | --- |
* | "({size} GB)" |
*
* @param {Embed_Captions_File_Size_GbInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_file_size_gb = /** @type {((inputs: Embed_Captions_File_Size_GbInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_File_Size_GbInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_file_size_gb(inputs)
	if (locale === "de") return de_embed_captions_file_size_gb(inputs)
	if (locale === "it") return it_embed_captions_file_size_gb(inputs)
	if (locale === "ru") return ru_embed_captions_file_size_gb(inputs)
	if (locale === "es") return es_embed_captions_file_size_gb(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_file_size_gb(inputs)
	if (locale === "ja") return ja_embed_captions_file_size_gb(inputs)
	if (locale === "hi") return hi_embed_captions_file_size_gb(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_file_size_gb(inputs)
	return en_embed_captions_file_size_gb(inputs)
});